import React, { useState } from "react";
import { Button, Dropdown, Layout, Menu, Drawer, Collapse } from 'antd'
const { Panel } = Collapse
import {
    ArrowUpIco,
    ArrowDownIco,
} from '../../../../../modules/CustomIcons'
import { useTranslation } from 'react-i18next'
import CreateTemplate from "../Header/CreateTemplate";
import Profile from "./profileResponsive";
import useResponsiveWidth from "hooks/useResponsiveWidth";

const ResponsiveDesign: React.FC = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState<any>([0])

    const openCloseCollapse = () => {
        setOpen((prev: any) => (prev.indexOf(0) != -1 ? [1] : [0]))
    }

    const collapseHeader = (text: any) => <p>{text}</p>

    const collapseExtra = () => <></>

    const responsiveWidth = useResponsiveWidth();


    return (
        <>
            {
                responsiveWidth < 650 && <Profile />
            }
            <Collapse
                expandIcon={(panelProps) => (
                    <Button
                        type={'ghost'}
                        className={'transparent responsive_collapse_button'}
                        // onClick={openCloseCollapse}
                        icon={
                            panelProps.isActive ? (
                                <ArrowUpIco className={'cursor_pointer settings_drawer_arrow'} />
                            ) : (
                                <ArrowDownIco className={'cursor_pointer settings_drawer_arrow'} />
                            )
                        }
                    />
                )}
                activeKey={[open]}
                onChange={openCloseCollapse}
                expandIconPosition={'right'}
                className="responsive_collapsed"
            >
                <Panel
                    header={collapseHeader(t("templates.selectedTemplates"))}
                    key="1"
                    extra={collapseExtra()}
                    collapsible={'header'}
                >
                    <CreateTemplate />
                </Panel>
            </Collapse>
        </>
    )
}

export default ResponsiveDesign;